module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/PhotographicForeground-6b61af15f6edb4a6409d21c0c9024e4c.png";